import { render, staticRenderFns } from "./WidgetItemTemplate.vue?vue&type=template&id=295cf31f&"
import script from "./WidgetItemTemplate.vue?vue&type=script&lang=js&"
export * from "./WidgetItemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports